// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorFallback_errorContainer__KL4zR","btn__wrapper":"ErrorFallback_btn__wrapper__gubVV"};